import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import {
  ReservationDetail,
  type ReservationDetailProps,
} from './ReservationDetail';

export * from './AttachReservationForm';
export * from './CancelBookingDialog';
export * from './CoverageChoice';
export * from './ReservationDetail';

type ReservationDetailDialogProps = ReservationDetailProps & {
  isOpen: boolean;
};

export const ReservationDetailDialog = (
  props: ReservationDetailDialogProps,
) => {
  const { isOpen, ...detailProps } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => !open && detailProps.onClose()}
    >
      <DialogContent className="flex max-h-[90vh] flex-col gap-0 overflow-hidden p-0 **:data-[slot=dialog-footer]:border-t **:data-[slot=dialog-footer]:px-6 **:data-[slot=dialog-footer]:py-4 **:data-[slot=dialog-footer]:shadow-[0_-2px_10px_rgba(0,0,0,0.1)] sm:max-w-[70vw] md:max-w-[70vw] lg:max-w-[60vw]">
        <DialogHeader className="border-b px-6 py-4 shadow-[0_2px_10px_rgba(0,0,0,0.1)]">
          <DialogTitle>{t('Booking details')}</DialogTitle>
          <DialogDescription className="sr-only">
            {t('Booking details')}
          </DialogDescription>
        </DialogHeader>

        <ReservationDetail {...detailProps} />
      </DialogContent>
    </Dialog>
  );
};
